module.exports = __webpack_public_path__ + "static/media/nielsen.736072f6.jpg";